import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { vehicleCategories } from "../../../../../../redux/vehicle-categories/action";
import { selectVehicleCategoriesListItems } from "../../../../../../redux/vehicle-categories/selector";

const ManagementVehicleCategories = () => {

    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const itemsData = useSelector(selectVehicleCategoriesListItems)
    const [
        columnDefs,
        setColumnDefs
    ] = useState({});
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'IsActive', headerName: 'Active', cellRenderer: 'yesNoRenderer' },
            { field: 'LogisticsVehicleCategoryName', headerName: 'Vehicle CategoryName', searchField: 'LogisticsVehicleCategoryName', sortable: true, filter: true, filterType: 'text' },
            { field: 'VehicleCategoryType', headerName: 'Vehicle Type' },
            { field: 'VehicleCategoryBodyType', headerName: 'Vehicle Body Type' },
            { field: 'VehicleCategoryFuelType', headerName: 'Vehicle Fuel Type' },
            { field: 'MaximumLoadingCapacity', headerName: 'Max Loading Capacity(kg)' },
            { field: 'CreatedOnUtc', headerName: 'CreatedOn', isDateValueFormat: true },
            { field: 'ModifiedOnUtc', headerName: 'ModifiedOn', isDateValueFormat: true },
        ]);
    }
    const fetchVehicleCategory = async () => {
        await dispatch(vehicleCategories.resetAction({ actionType: 'list' }))
        await dispatch(vehicleCategories.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/vehicle-categories/list`, entity: 'vehicles', jsonData: {
                "PageNumber": pageData,
                "PageSize": 10,
                "SortField": "Id",
                "SortOrder": "desc",
            }
        }))
    }
    useEffect(() => {
        createColumnDefs()
        fetchVehicleCategory()
    }, [pageData, pageSize])

    const handleAdd = async () => {
        await dispatch(vehicleCategories.resetAction({ actionType: 'query' }))
        await navigate(`${0}`)
    }

    const handleDelete = async (data: any) => {
        await dispatch(vehicleCategories.delete({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/vehicle-categories/delete`,
            entity: 'vehicles',
            jsonData: {
                Context: {},
                Records: [
                    {
                        Id: data?.Id
                    }
                ]
            }
        }))
        await fetchVehicleCategory()
    }

    const handleEdit = (data: any) => {
        navigate(`${data?.Id}`)
    }
    const handleReloadData = () => {
        fetchVehicleCategory()
    }
    const additionButtons: any = [
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
                    <title>Add Vehicle Category</title>
                    <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
                </svg>,
            callback: () => handleAdd(),
        },
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
                    <title>Reload this table</title>
                    <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>,
            callback: () => handleReloadData(),
        },
    ];

    const handleSearch = (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
            searchCriteria = [{
                FieldName: data?.column,
                FieldText: data?.column,
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        } else {
            searchCriteria = [{
                FieldName: "LogisticsVehicleCategoryName",
                FieldText: "LogisticsVehicleCategoryName",
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        }
        dispatch(vehicleCategories.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/vehicle-registations/list`,
            entity: 'vehicles',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
                "Searches": searchCriteria,
            }
        }));
    }

    return (
        <>
            {itemsData?.isLoading ? <PageLoader />
                :
                <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
                    enableFilter={true} onSearch={handleSearch} paginationData={itemsData?.result?.pagination} onEdit={handleEdit} additionButtons={additionButtons} onDelete={handleDelete} headingName="Vehicle Categories" />
            }
        </>
    );
};

export default ManagementVehicleCategories;


